import axios from 'axios';


// Baseurl(Modify this according to .env setup)
export const API_BASE_URL = process.env.REACT_APP_API_URL || "https://g99nt4cz-5000.inc1.devtunnels.ms/api/v1";

// Create Axios instance for dashboard APIs
export const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers:{
        'Content-Type': 'application/json'
    }
})



